import styled from "styled-components";

export const SoundButtonContainer = styled.button`
  padding: 0.75rem;
  display: flex;
  font-size: 0;

  border-radius: 4px;
  background-color: rgba(172, 172, 172, 0.3);

  @media (max-width: 768px) {
    display: none;
  }

  & {
    transition: 0.3s all;
  }

  svg {
    width: 21px;
    height: 21px;
  }

  :hover {
    cursor: pointer;

    background-color: rgba(172, 172, 172, 0.7);
  }
`;
